export const CLOSE_ROUNDED_MODAL_BUTTON = "close-rounded-modal";
